(function () {
  'use strict';

  function initFAQ() {
    var section = document.getElementById('invi-faq');
    if (!section) return;

    var buttons = section.querySelectorAll('.invi-faq-question');
    if (!buttons.length) return;

    function openItem(btn, item, wrap) {
      var inner = wrap.querySelector('.invi-faq-answer');
      btn.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      wrap.style.maxHeight = (inner.scrollHeight + 44) + 'px';
    }

    function closeItem(btn, item, wrap) {
      btn.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      wrap.style.maxHeight = '0';
    }

    function toggleItem(btn) {
      var item = btn.closest('.invi-faq-item');
      var wrap = item.querySelector('.invi-faq-answer-wrap');
      var isOpen = item.classList.contains('is-open');

      buttons.forEach(function (b) {
        var i = b.closest('.invi-faq-item');
        var w = i.querySelector('.invi-faq-answer-wrap');
        closeItem(b, i, w);
      });

      if (!isOpen) {
        openItem(btn, item, wrap);
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleItem(btn);
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buttons.forEach(function (btn) {
          var item = btn.closest('.invi-faq-item');
          if (item.classList.contains('is-open')) {
            var wrap = item.querySelector('.invi-faq-answer-wrap');
            var inner = wrap.querySelector('.invi-faq-answer');
            if (inner) wrap.style.maxHeight = (inner.scrollHeight + 44) + 'px';
          }
        });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }
})();